import type { ClassGroup } from '@/api/types'

/**
 * 班级 Mock 数据 (TEACH-02)
 * K2决策: 课卡默认不可跨校区 — 班级绑定单一校区
 * Q决策: 增加会员卡类型(cardType)，教室改非必填，课程模板改可选
 */

export const mockClasses: ClassGroup[] = [
  {
    id: 'cg-001',
    brandId: 'b-001',
    campusId: 'c-001',
    templateId: 'tpl-001',
    templateName: '少儿篮球基础班',
    name: '周六篮球班',
    teacherId: 'u-teacher-001',
    teacherName: '赵老师',
    classroomId: 'cr-001',
    classroomName: '篮球馆A',
    cardType: 'GROUP',
    capacity: 12,
    enrolledCount: 8,
    status: 'ACTIVE',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
    createdAt: '2025-08-25T08:00:00Z',
    updatedAt: '2025-09-01T09:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cg-002',
    brandId: 'b-001',
    campusId: 'c-001',
    templateId: 'tpl-002',
    templateName: '私教体能训练',
    name: '张三体能私教',
    teacherId: 'u-teacher-001',
    teacherName: '赵老师',
    classroomId: 'cr-003',
    classroomName: '综合训练馆',
    cardType: 'PRIVATE',
    capacity: 1,
    enrolledCount: 1,
    status: 'ACTIVE',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
    createdAt: '2025-08-28T08:00:00Z',
    updatedAt: '2025-09-01T09:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cg-003',
    brandId: 'b-001',
    campusId: 'c-002',
    templateId: 'tpl-003',
    templateName: '少儿足球启蒙',
    name: '周日足球班',
    teacherId: 'u-teacher-002',
    teacherName: '周老师',
    classroomId: 'cr-002',
    classroomName: '足球场',
    cardType: 'YOUTH',
    capacity: 15,
    enrolledCount: 10,
    status: 'ACTIVE',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
    createdAt: '2025-08-26T08:00:00Z',
    updatedAt: '2025-09-05T10:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-teacher-002',
  },
  {
    id: 'cg-004',
    brandId: 'b-001',
    campusId: 'c-001',
    templateId: 'tpl-005',
    templateName: '少儿游泳入门',
    name: '周三游泳班',
    teacherId: 'u-teacher-001',
    teacherName: '赵老师',
    classroomId: 'cr-004',
    classroomName: '游泳馆',
    cardType: 'YOUTH',
    capacity: 8,
    enrolledCount: 6,
    status: 'ACTIVE',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
    createdAt: '2025-08-27T08:00:00Z',
    updatedAt: '2025-09-10T11:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-teacher-001',
  },
  {
    id: 'cg-005',
    brandId: 'b-001',
    campusId: 'c-002',
    templateId: 'tpl-001',
    templateName: '少儿篮球基础班',
    name: '朝阳篮球班',
    teacherId: 'u-teacher-002',
    teacherName: '周老师',
    classroomId: 'cr-003',
    classroomName: '综合训练馆',
    cardType: 'GROUP',
    capacity: 12,
    enrolledCount: 5,
    status: 'PLANNED',
    startDate: '2025-10-15',
    endDate: '2026-01-31',
    createdAt: '2025-09-20T08:00:00Z',
    updatedAt: '2025-09-20T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cg-006',
    brandId: 'b-001',
    campusId: 'c-001',
    templateId: 'tpl-006',
    templateName: '少儿舞蹈基础',
    name: '周五舞蹈班',
    teacherId: 'u-teacher-001',
    teacherName: '赵老师',
    classroomId: 'cr-005',
    classroomName: '舞蹈教室',
    cardType: 'YOUTH',
    capacity: 10,
    enrolledCount: 0,
    status: 'PAUSED',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
    createdAt: '2025-08-30T08:00:00Z',
    updatedAt: '2025-09-25T16:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cg-007',
    brandId: 'b-001',
    campusId: 'c-002',
    templateId: 'tpl-002',
    templateName: '私教体能训练',
    name: '李四体能私教',
    teacherId: 'u-teacher-002',
    teacherName: '周老师',
    classroomId: 'cr-003',
    classroomName: '综合训练馆',
    cardType: 'PRIVATE',
    capacity: 1,
    enrolledCount: 1,
    status: 'COMPLETED',
    startDate: '2025-06-01',
    endDate: '2025-08-31',
    createdAt: '2025-05-25T08:00:00Z',
    updatedAt: '2025-09-01T09:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-teacher-002',
  },
  {
    id: 'cg-008',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '体验篮球私教',
    teacherId: 'u-teacher-001',
    teacherName: '赵老师',
    cardType: 'PRIVATE',
    capacity: 1,
    enrolledCount: 0,
    status: 'PLANNED',
    startDate: '2025-11-01',
    endDate: '2026-01-31',
    createdAt: '2025-10-20T08:00:00Z',
    updatedAt: '2025-10-20T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
]
